export function applyFriction(object, { time, friction = 0.02 }) {
  if (object.velocity.x === 0 && object.velocity.y === 0) return

  const frictionDelta = friction * time.deltaTime

  // Friction
  object.velocity.x -=
    Math.sign(object.velocity.x) * frictionDelta * Math.abs(object.velocity.x)
  object.velocity.y -=
    Math.sign(object.velocity.y) * frictionDelta * Math.abs(object.velocity.y)
}
